import { Tag } from "lucide-react";
import CrudManager, { slugify } from "@/components/admin/CrudManager";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import ImageUpload from "@/components/admin/ImageUpload";
import { ADMIN } from "@/constants/testIds";

const DEFAULT = { name: "", slug: "", logo: "", description: "", story: "", order: 0, published: true };

export default function AdminBrands() {
  return (
    <CrudManager
      title="Brands"
      subtitle="Manage the multi-brand wholesale portfolio."
      endpoint="/admin/brands"
      defaultItem={DEFAULT}
      testId={ADMIN.brandsList}
      listRender={(b) => (
        <div className="flex items-center gap-4">
          <div className="h-14 w-14 rounded-sm bg-secondary overflow-hidden shrink-0 flex items-center justify-center">
            {b.logo ? <img src={b.logo} alt={b.name} className="w-full h-full object-contain" /> : <Tag size={16} className="text-foreground/40" />}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[0.65rem] tracking-widest uppercase text-gold">Brand</p>
            <p className="mt-0.5 font-serif text-lg text-foreground truncate">{b.name}</p>
            <p className="text-xs text-foreground/60 truncate">{b.description}</p>
          </div>
        </div>
      )}
      formRenderer={(v, patch) => (
        <>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <Label>Brand Name</Label>
              <Input className="mt-2 rounded-sm" value={v.name} onChange={(e) => patch({ name: e.target.value, slug: v.slug || slugify(e.target.value) })} />
            </div>
            <div>
              <Label>Slug</Label>
              <Input className="mt-2 rounded-sm" value={v.slug} onChange={(e) => patch({ slug: slugify(e.target.value) })} />
            </div>
          </div>
          <div>
            <Label>Short Description</Label>
            <Textarea className="mt-2 rounded-sm" value={v.description} onChange={(e) => patch({ description: e.target.value })} />
          </div>
          <div>
            <Label>Brand Story (long-form, optional)</Label>
            <Textarea className="mt-2 rounded-sm min-h-[100px]" value={v.story} onChange={(e) => patch({ story: e.target.value })} />
          </div>
          <ImageUpload label="Brand Logo" value={v.logo} onChange={(v2) => patch({ logo: v2 })} />
          <div className="grid md:grid-cols-2 gap-4 items-end">
            <div>
              <Label>Display Order</Label>
              <Input type="number" className="mt-2 rounded-sm" value={v.order} onChange={(e) => patch({ order: parseInt(e.target.value) || 0 })} />
            </div>
            <label className="flex items-center gap-3 p-3 rounded-sm border border-border/60 bg-secondary/40 cursor-pointer">
              <Switch checked={v.published} onCheckedChange={(c) => patch({ published: c })} />
              <span className="text-sm">Published</span>
            </label>
          </div>
        </>
      )}
    />
  );
}
